(function () {

  async function insertSectionCartDrawer() {
    if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return;

    var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items');
    if (!cartDrawerItems) return;
    if (cartDrawerItems.classList.contains('is-empty')) return;

    var wrapper = document.createElement('div');
    wrapper.classList.add('cart-drawer-items-wrapper');
    cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems);
    wrapper.appendChild(cartDrawerItems);

    const upsells = document.querySelector('#cart-drawer-upsell-wrapper');
    wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML);

    if (!document.querySelector('.cart-drawer-upsell-list li')) {
      const upsellEl = document.querySelector('#cart-drawer-upsell');
      if (upsellEl) upsellEl.remove();
    } else {
      initCyliaUpsellSlider();
    }
  }

  insertSectionCartDrawer();

  window.onChangeKsUpsellVariantSelector = function (select, event) {
    event.preventDefault();
    const imgSrc = select.options[select.selectedIndex].dataset.variantImg;
    if (imgSrc) {
      const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img');
      if (img) img.src = imgSrc;
    }
  };

  function initCyliaUpsellSlider() {
    const list = document.querySelector('.cart-drawer-upsell-list[data-list-style-cart-drawer="scroll"]');
    if (!list) return;

    const items = list.querySelectorAll('.cart-drawer-upsell-list-item');
    const total = items.length;
    if (total <= 1) return;

    const prevBtn = document.querySelector('.cart-drawer-upsell-prev');
    const nextBtn = document.querySelector('.cart-drawer-upsell-next');

    const header = document.querySelector('.cart-drawer-upsell-header');
    let dotsContainer = null;

    if (header) {
      dotsContainer = document.createElement('div');
      dotsContainer.className = 'cylia-upsell-dots';
      for (let i = 0; i < total; i++) {
        const dot = document.createElement('button');
        dot.className = 'cylia-upsell-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Produkt ' + (i + 1));
        dot.dataset.idx = i;
        dotsContainer.appendChild(dot);
      }
      const navEl = header.querySelector('.cart-drawer-upsell-navigation');
      if (navEl) {
        navEl.replaceWith(dotsContainer);
      } else {
        header.appendChild(dotsContainer);
      }
    }

    let current = 0;
    const CARD_WIDTH = 146;

    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx >= total) idx = total - 1;
      current = idx;
      list.style.transform = 'translateX(-' + (current * CARD_WIDTH) + 'px)';

      if (dotsContainer) {
        dotsContainer.querySelectorAll('.cylia-upsell-dot').forEach(function (d, i) {
          d.classList.toggle('active', i === current);
        });
      }

      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === total - 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    if (dotsContainer) {
      dotsContainer.addEventListener('click', function (e) {
        const dot = e.target.closest('.cylia-upsell-dot');
        if (dot) goTo(parseInt(dot.dataset.idx));
      });
    }

    goTo(0);
  }

  function listenCartDrawer() {
    const element = document.querySelector('cart-drawer');
    if (!element) return;

    let timer;

    const observer = new MutationObserver((mutations) => {
      if (timer) clearTimeout(timer);

      timer = setTimeout(async () => {
        const response = await fetch(window.location.href);
        const text = await response.text();
        const newDocument = new DOMParser().parseFromString(text, 'text/html');

        const oldWrapper = document.querySelector('#cart-drawer-upsell-wrapper');
        const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper');
        if (oldWrapper && newWrapper) oldWrapper.replaceWith(newWrapper);

        const existingWrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper');
        if (existingWrapper) {
          const cartItems = existingWrapper.querySelector('cart-drawer-items');
          if (cartItems) existingWrapper.parentNode.insertBefore(cartItems, existingWrapper);
          existingWrapper.remove();
        }

        insertSectionCartDrawer();
      }, 250);
    });

    observer.observe(element, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  listenCartDrawer();

})();